import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styles from "./slider-rail.css";
const SliderRail = ({ getRailProps, railColor, trackSliderInnerStyle}) => {
    const customStyles = {
        backgroundColor: railColor,
        ...trackSliderInnerStyle
    };
    return (
        <Fragment>
            <div styleName={"styles.railOuter"} {...getRailProps()} />
            <div styleName={"styles.railInner"} style={customStyles} />
        </Fragment>
    );
};

SliderRail.propTypes = {
    getRailProps: PropTypes.func.isRequired,
    railColor: PropTypes.string,
    trackSliderInnerStyle: PropTypes.object
};

export default SliderRail;
